import { Button, Card, Form, Input, Typography } from 'antd';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ToastVariant } from '../../../../components/Toast/toast.model';
import { toastService } from '../../../../components/Toast/toast.service';
import { firestore } from '../../../../firebase/firebase';
import { FirestoreCollection } from '../../../../firebase/firebase.models';
import { useUpdateUserInformation } from '../../../../firebase/hooks/updateUserInformation.hook';
import { UpdateInformation } from '../../../../models/MojaTablica.model';
import { useAuth } from '../../../Auth/AuthContext';

const { Text } = Typography;

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 18 },
};

export const BasicInfo: React.FC = () => {
  const [componentDisabled, setComponentDisabled] = useState<boolean>(true);
  const { currentUser, updateInformation } = useAuth();

  const [initialInformation, setInitialInformation] = useState<UpdateInformation>();
  const [updated, setUpdated] = useState<boolean>(false);

  const [form] = Form.useForm();
  const { t } = useTranslation();

  useEffect(() => {
    const userDoc = firestore.collection(FirestoreCollection.USERS).doc(currentUser.uid);
    userDoc.get().then((snapshot) => {
      const data = snapshot.data();
      if (data) {
        setInitialInformation({
          firstName: data.firstName,
          lastName: data.lastName,
        } as UpdateInformation);
        form.setFieldsValue({
          firstName: data.firstName,
          lastName: data.lastName,
        });
        form.resetFields();
      }
    });
  }, [updated]);

  const handleUpdateUser = async (data, uid) => {
    await useUpdateUserInformation(data, uid, t); // Pass t as an argument
  };

  const onFinish = (values: UpdateInformation) => {
    setComponentDisabled(!componentDisabled);
    // update firestore user information
    handleUpdateUser(values, currentUser.uid);
    // useUpdateUserInformation(values, currentUser.uid);
    // update auth currentUser information
    updateInformation(values.firstName + ' ' + values.lastName);
  };

  const onFinishFailed = (errorInfo: any) => {
    toastService.show(errorInfo, t('ERROR'), { variant: ToastVariant.ERROR });
  };

  const onReset = () => {
    setUpdated(!updated);
  };

  return (
    <Card className="shadow-sm border border-gray-200 rounded-lg" bodyStyle={{ padding: '16px' }}>
      <div className="space-y-3">
        <Text className="text-gray-700 text-sm font-medium">{t('BASIC_INFORMATION') || 'Podstawowe informacje'}</Text>

        <Form
          {...layout}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          initialValues={{
            firstName: initialInformation ? initialInformation.firstName : '',
            lastName: initialInformation ? initialInformation.lastName : '',
          }}
          autoComplete="off"
          form={form}
          disabled={componentDisabled}
          size="small">
          <Form.Item
            label={<Text className="text-sm">{t('FIRST_NAME')}</Text>}
            name="firstName"
            className="!mb-3"
            rules={[{ required: true, message: t('VALIDATION.FIELD_REQUIRED') }]}>
            <Input className="text-sm" />
          </Form.Item>

          <Form.Item
            label={<Text className="text-sm">{t('LAST_NAME')}</Text>}
            name="lastName"
            className="!mb-3"
            rules={[{ required: true, message: t('VALIDATION.FIELD_REQUIRED') }]}>
            <Input className="text-sm" />
          </Form.Item>

          <Form.Item wrapperCol={{ offset: 6, span: 18 }} hidden={componentDisabled} className="!mb-0">
            <div className="space-x-2">
              <Button type="primary" htmlType="submit" size="small">
                {t('SAVE')}
              </Button>
              <Button htmlType="button" onClick={onReset} size="small">
                {t('RESET')}
              </Button>
            </div>
          </Form.Item>
        </Form>

        {componentDisabled && (
          <div className="flex justify-end">
            <Button size="small" onClick={() => setComponentDisabled(!componentDisabled)}>
              {t('EDIT')}
            </Button>
          </div>
        )}
      </div>
    </Card>
  );
};
